import template from './questionModal.html';
import controller from './questionModal.controller';
import './questionModal.scss';

let questionModalComponent = {
  restrict: 'E',
  bindings: {
    modalId: '<',
    title: '@',
    description: '<',
    options: '<',
    onSelection: '&',
    isInception : '&',
    data: '<',
  },
  transclude: {
    descriptionTextarea: '?descriptionTextarea',
  },
  template,
  controller
};

export default questionModalComponent;



// WEBPACK FOOTER //
// ./client/app/components/questionModal/questionModal.component.js